import { render, staticRenderFns } from "./OrderModify.vue?vue&type=template&id=3814c36c&"
import script from "./OrderModify.vue?vue&type=script&lang=js&"
export * from "./OrderModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports